'use strict';
/**
 * tab
 */

export const tab = (() => {
    const $tab = $('.js-tab');
    const $panel = $('.js-panel');

    const init = () => {
        $(document).on('click', '.js-tab', function(e) {
            const $this = $(e.currentTarget);
            const $target = $this.attr('data-id');
            const $targetClass = $('.panel' + $target);

            $tab.removeClass('is-active');
            $panel.removeClass('is-active');

            $this.addClass('is-active');
            $targetClass.addClass('is-active');
        });
    };

    // public
    return {
        init: init
    };
})();
